import { render, staticRenderFns } from "./settings-spacing.vue?vue&type=template&id=7cdc74ec&"
import script from "./settings-spacing.vue?vue&type=script&lang=js&"
export * from "./settings-spacing.vue?vue&type=script&lang=js&"
import style0 from "./settings-spacing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports